module.exports = __webpack_public_path__ + "img/primary_pain.9df7587c.svg";